import { render } from "./ModalAddBankAccount.vue?vue&type=template&id=2e9a77b4"
import script from "./ModalAddBankAccount.vue?vue&type=script&lang=js"
export * from "./ModalAddBankAccount.vue?vue&type=script&lang=js"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__